import { render } from "./MyNavBar.vue?vue&type=template&id=8d4c1982&ts=true"
import script from "./MyNavBar.ts?vue&type=script&lang=ts&external"
export * from "./MyNavBar.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__